const loadScript = (src, callback, id) => {
  if (!src) {
    return;
  }

  const d = document;
  const ijs = d.getElementsByTagName("script")[0];
  if (id && d.getElementById(id)) {
    // run callback as script is already loaded
    callback?.();

    return;
  }
  const js = d.createElement("script");
  js.id = id;
  js.onload = () => {
    callback?.();
  };
  js.src = src;

  if (ijs && ijs.parentNode) {
    ijs.parentNode.insertBefore(js, ijs);
  }
};

const loadScriptWhenReady = ({ src, callback = null, id, processNodeEnv }) => {
  if (processNodeEnv === "test") {
    callback?.();
    return;
  }
  if (document.readyState === "complete") {
    // if page is already loaded, get the script
    loadScript(src, callback, id);
  } else {
    // if page is not yet loaded, add an event listener
    window.addEventListener("load", () => {
      loadScript(src, callback, id);
    });
  }
};

export default loadScriptWhenReady;
